import React, { useRef, useState } from "react";
import { Icon, Label, TeachingBubble, TextField } from "@fluentui/react";
export var CaseType;
(function (CaseType) {
    CaseType[CaseType["undefined"] = 0] = "undefined";
    CaseType[CaseType["upperCase"] = 1] = "upperCase";
    CaseType[CaseType["lowerCase"] = 2] = "lowerCase";
})(CaseType || (CaseType = {}));
export const XTextField = (props) => {
    const ref = useRef(null);
    const [showHelp, setShowHelp] = useState(false);
    const onChanged = (_, value) => {
        if (props.onChange == null)
            return;
        switch (props.caseType) {
            case CaseType.lowerCase:
                props.onChange((value || '').toLowerCase());
                break;
            case CaseType.upperCase:
                props.onChange((value || '').toUpperCase());
                break;
            case CaseType.undefined:
            default:
                props.onChange(value || '');
                break;
        }
    };
    return React.createElement(TextField, { autoComplete: "0", autoFocus: props.autoFocus, borderless: props.borderless, className: props.className, disabled: props.disabled || false, errorMessage: props.errorMessage || '', label: props.label, title: props.label || '', maxLength: props.maxLength, multiline: props.multiline, onChange: onChanged, onKeyDown: props.onKeyDown, onRenderPrefix: props.onRenderPrefix, onRenderSuffix: props.onRenderSuffix, placeholder: props.placeholder || props.label || '', readOnly: props.readonly || false, required: props.required || false, style: props.style, styles: props.styles, value: props.value || '', onKeyUp: props.onKeyUp, onRenderLabel: props.help != null ? () => {
            return React.createElement(Label, { className: props.required ? 'input-required' : '' },
                props.label,
                props.help != null && React.createElement("small", { ref: ref },
                    React.createElement(Icon, { style: {
                            fontWeight: 'bold',
                            color: '#0078d4',
                            fontSize: '0.8em',
                            border: 'solid 1px #0078d4',
                            borderRadius: '50%',
                            background: 'white',
                            padding: '1px',
                            marginLeft: '3px',
                            userSelect: 'none',
                            cursor: 'pointer'
                        }, iconName: 'Help', onClick: (ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            setShowHelp(true);
                        } }),
                    showHelp && React.createElement(TeachingBubble, { onDismiss: () => setShowHelp(false), target: ref.current }, props.help)));
        } : undefined, onClick: props.onClick });
};
